// Google Analytics Helper
// Tracking de eventos personalizados

export const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // Reemplazar con tu ID real

// Función helper para trackear eventos
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Eventos específicos del sitio
export const analytics = {
  // Trackear envío de formulario de contacto
  // PRIVACY: No enviar PII (name, email) a Google Analytics per GDPR/ToS
  trackContactFormSubmit: (formData) => {
    trackEvent('contact_form_submit', {
      event_category: 'engagement',
      event_label: 'Contact Form',
      has_company: !!formData.company,
      message_length: formData.message?.length || 0,
    });
  },

  // Trackear click en botón de contacto
  trackContactButtonClick: (buttonLocation) => {
    trackEvent('contact_button_click', {
      event_category: 'engagement',
      event_label: buttonLocation, // 'header', 'hero', 'footer'
    });
  },

  // Trackear scroll depth
  trackScrollDepth: (percentage) => {
    trackEvent('scroll_depth', {
      event_category: 'engagement',
      event_label: `${percentage}%`,
      value: percentage,
    });
  },

  // Trackear visualización de sección
  trackSectionView: (sectionName) => {
    trackEvent('section_view', {
      event_category: 'engagement',
      event_label: sectionName,
    });
  },

  // Trackear click en video
  trackVideoPlay: () => {
    trackEvent('video_play', {
      event_category: 'engagement',
      event_label: 'Showcase Video',
    });
  },

  // Trackear tiempo en página
  trackTimeOnPage: (seconds) => {
    trackEvent('time_on_page', {
      event_category: 'engagement',
      value: seconds,
    });
  },
};

export default analytics;
